import React from 'react';
import { Card, CardBody } from "reactstrap";
import avtarImage1 from "../../assets/images/users/avatar-1.jpg";
import { useSelector } from 'react-redux';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

const Workflow_ListView = ({delete_workflow}) => {
const navigate = useNavigate()
const workflow_list = useSelector((state)=>{
   return state.WorkFlowBuilder.workflow_list
})

  return (
    <React.Fragment>
        { workflow_list.data.map((workflow , index)=>{
         const { Workflow_ID,Workflow_Title,Workflow_Logo , Group_ID , Type , Created_At , Category , Status , Created_By , Updated_At , Group } = workflow
         return <Card key={index}>
            <CardBody className="no_padding">
                <div className="listjs-table" id="customerList">
                    <div className="table-responsive">
                        <table
                            className="table align-middle table-nowrap  no_margin"
                            id="customerTable"
                            >
                            <thead className="table-light">
                                <tr>
                                <th>Action</th>
                                <th>Workflow Title</th>
                                {/* <th                                   
                                    data-sort="type"
                                >
                                    Description
                                </th> */}
                                
                                <th                                   
                                    data-sort="group"
                                >
                                    Group
                                </th> 
                                <th                                    
                                    data-sort="category"
                                >
                                    Category
                                </th>
                                <th className="" data-sort="last_use">
                                    Last Use
                                </th>
                                </tr>
                            </thead>
                            <tbody className="list form-check-all">
                                <tr>
                                        <td>
                                            <i onClick={()=>{
                    navigate("/workflow",{
                      state:{
                        Workflow_ID:workflow.Workflow_ID
                      }
                    })
                   }} className="mdi mdi-eye-circle-outline"/>
                                            <span onClick={()=>{
                                                delete_workflow(workflow.Workflow_ID)
                                            }} ><i className="ri-delete-bin-line"/></span>                                       
                                        </td>
                                        <td>                                        
                                            <div className="d-flex gap-2 align-items-center">
                                            <div className="flex-shrink-0">
                                                <img
                                                    src={Workflow_Logo}
                                                    alt=""
                                                    className="avatar-xs rounded-circle"
                                                />
                                            </div>
                                            <div className="flex-grow-1">{Workflow_Title}</div>
                                            </div>
                                        </td>
                                        {/* <td className="description">Description</td> */}
                                        <td className="Group">{Group.Group_Name}</td>
                                        <td className="category">{Category}</td>
                                        <td className="last_use">
                                        {moment(Group.Updated_At).format('YYYY-MM-DD')}

                                        </td>
                                        </tr>
                                    
                               
                            </tbody>
                            </table>
                    </div>
                </div>
            </CardBody>
          </Card>
        })}
       
    </React.Fragment>
  )
}

export default Workflow_ListView